import React, { createContext, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { isAuthenticated, getCurrentUser, logout } from 'api/auth';
import { cacheAfterLogin } from 'api/cacheAfterLogin';

// Create the authentication context
export const AuthContext = createContext();

// Custom hook to use the auth context
export const useAuth = () => useContext(AuthContext);

// Provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated on component mount
    const checkAuth = () => {
      if (isAuthenticated()) {
        const currentUser = getCurrentUser();
        setUser(currentUser);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  // Handle user login
  const login = async (userData) => {
    console.log('AuthContext: Starting login process...', userData);
    setUser(userData);
    
    // Wait for user state to be set before proceeding
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Fetch and cache employee/substore data after login
    try {
      console.log('AuthContext: Starting cacheAfterLogin...');
      await cacheAfterLogin();
      console.log('AuthContext: Successfully cached employee and substore data after login');
    } catch (err) {
      console.error('AuthContext: Failed to cache employee/substore data after login', err);
    }
  };

  // Handle user logout
  const handleLogout = () => {
    logout();
    setUser(null);
  };

  // Context value
  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    login,
    logout: handleLogout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};
